import { paymentTypeMap } from "../../../core/utils";

export function paymentTypeFromOrderForm(context: Record<string, any>) {
  if (context.payment_type) return context.payment_type;
  if (!context.orderForm) return null;

  const payments = context.orderForm.paymentData?.payments || [];
  const systems = context.orderForm.paymentData?.paymentSystems || [];
  if (!payments.length || !systems.length) return null;

  const selectedPayment = payments.find((p: { paymentSystem: string }) => p?.paymentSystem) || payments[0];
  const id = String(selectedPayment?.paymentSystem || '').trim();
  if (!id) return null;

  const system = systems.find((s: { id: string }) => String(s.id) === id);
  const name = system?.name?.toLowerCase() || '';
  const match = paymentTypeMap.find(([key]) => name.includes(key));

  return match ? match[1] : null;
}
